import React, { lazy, useEffect, createElement } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import {
  isChunkLoadError,
  shouldReloadForChunkError,
  markChunkReloadAttempt,
  clearChunkReloadAttempt
} from "./chunkError";

export { isChunkLoadError };

function ChunkReloadFallback() {
  useEffect(() => {
    window.location.reload();
  }, []);

  return createElement(
    "div",
    {
      style: {
        padding: 24,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontFamily: "sans-serif"
      },
      role: "status",
      "aria-live": "polite"
    },
    createElement(CircularProgress, { sx: { color: "#1e293b" } })
  );
}

export default function lazyWithRetry<T extends React.ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
  identifier?: string
) {
  return lazy(async () => {
    try {
      return await factory();
    } catch (error) {
      if (isChunkLoadError(error)) {
        const scope = identifier ?? "lazy";

        if (shouldReloadForChunkError(scope)) {
          markChunkReloadAttempt(scope);
          return { default: ChunkReloadFallback as unknown as T };
        }
        clearChunkReloadAttempt(scope);
      }

      throw error;
    }
  });
}
